
import { ResponsivePieCanvas } from '@nivo/pie'
import moment from 'moment';

const OutofProtocolTreatments = ({ data }) => {

    return (<div className='reportChart' style={ { width: '100%', height: 300, maxHeight: 340 } }>
        <h4>Out of Protocol Treatments by Staff</h4>
        {data.length > 0 ? <ResponsivePieCanvas
                data={ data.map((d) => {
                    return {
                        id: d.staff,
                        label: "Skin Type " + d.staff,
                        value: d.count
                    }
                }) }
                tooltip={ point => {
                    return <div style={ {
                        background: '#fff',
                        padding: '10px',
                        borderRadius: '5px',
                        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.25)',
                    } }><b>{point.datum.id}</b> Out of Protocol Treatments: {point.datum.formattedValue}</div>;
                } }
                margin={ { top: 40, right: 0, bottom: 40, left: 0 } }
                innerRadius={ 0.6 }
                padAngle={ 0.7 }
                activeOuterRadiusOffset={ 8 }
                colors={[
                    '#93d5ed',
                    '#5c9ceb',
                    '#2e7de4',
                    '#1d5ba6',
                ]}
                borderColor="#000000"
                enableArcLinkLabels={ true }
                arcLinkLabelsSkipAngle={ 10 }
                arcLinkLabelsTextColor="#333333"
                arcLinkLabelsThickness={ 2 }
                arcLinkLabelsColor={ { from: 'color' } }
                arcLabelsSkipAngle={ 10 }
                arcLabelsTextColor="#333333"
            /> : <div className='noData'>No data available</div>}
    </div>)
}


export default OutofProtocolTreatments;